module.exports = __webpack_public_path__ + "static/andy-burnham_profile.47b77f06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/andy-burnham_profile.jpg
// module id = 470
// module chunks = 35783957827783